import { render, staticRenderFns } from "./QcDistribution.vue?vue&type=template&id=17989874&scoped=true"
import script from "./QcDistribution.vue?vue&type=script&lang=js"
export * from "./QcDistribution.vue?vue&type=script&lang=js"
import style0 from "./QcDistribution.vue?vue&type=style&index=0&id=17989874&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17989874",
  null
  
)

export default component.exports